import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/errors';

import { environment } from 'apps/ff-frontend/src/environments/environment';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { OpportunityBoardType } from '@fitness-force/enum';
import { ClientCheckInResponse, CreateResponse } from '@fitness-force/models';

@Injectable({
  providedIn: 'root',
})
export class CheckInService {
  constructor(private http: HttpClient, private router: Router) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getWhoIsInTheClub(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/clients/who_is_in_club`,
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCheckIns(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(`${environment.BASE_URL}/tenants/${tenantId}/check_ins`, {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClientCheckIns(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.paramName, p.paramValue);
      });
    }
    return this.http
      .get(`${environment.BASE_URL}/tenants/${tenantId}/clients/check_ins`, {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markClientCheckedIn(tenantId: number, clientId: number, data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/mark_client_checkedin`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteClientCheckedIn(tenantId: number, checkedInId: number, checkInId:number) {
    return this.http
      .delete(`${environment.BASE_URL}/tenants/${tenantId}/clients/${checkedInId}/check_ins/${checkInId}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCheckInsByClientId(clientId: number, allParams: Array<string> = []):Observable<ClientCheckInResponse> {
    let parsedParams = new HttpParams();
    if (allParams.length > 0) {
      allParams.forEach((p: any) => {
        parsedParams = parsedParams.append(p.paramName, p.paramValue);
      });
    }
    return this.http
      .get(`${environment.BASE_URL}/clients/${clientId}/check_ins`, {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
